<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">401</h1>
            <h4 class="pt-3">{{ $t('other.p401Header') }}</h4>
            <p class="text-muted">{{ $t('other.p401Text') }}</p>
            <router-link to="/">
                <b-button variant="primary">{{ $t('other.return') }}</b-button>          
            </router-link>            
          </div>          
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "Page401",  
};
</script>
